import { render, staticRenderFns } from "./counterpartiesList.vue?vue&type=template&id=8dacd058&scoped=true"
import script from "./counterpartiesList.vue?vue&type=script&lang=js"
export * from "./counterpartiesList.vue?vue&type=script&lang=js"
import style0 from "./counterpartiesList.vue?vue&type=style&index=0&id=8dacd058&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dacd058",
  null
  
)

export default component.exports